import 'react-quill/dist/quill.snow.css';

// * the bubble style theme used with ReadOnly true
// import 'react-quill/dist/quill.bubble.css';
import PropTypes from 'prop-types';
import React from 'react';
import ReactQuill from 'react-quill';// TExt Editor

import useUtilities from '../../hooks/useUtilities';
import { requiredColorCode } from '../../Styles/componentStyles';
export const invalidStyle = {
    border: `2px solid ${requiredColorCode}`,
};
const QuillAdvancedTextArea = ({value,setValue,placeholder, modules,name,setIsReplanning, ...props}) => {
    QuillAdvancedTextArea.propTypes = {
        value: PropTypes.string,
        theme: PropTypes.string,
        setIsReplanning: PropTypes.func,
        placeholder: PropTypes.string,
        readOnly: PropTypes.bool,
        modules: PropTypes.any,
        width: PropTypes.any,
        height: PropTypes.any,
        name: PropTypes.any,
        setValue: PropTypes.func,
    };
    const { errors, showErrors } =useUtilities();
    const error = name in errors ? errors[name] : undefined;

    const modulesDefault = {
        toolbar: [
            [{ font: [] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'italic', 'underline', 'strike'],
            [{ color: [] }, { background: ['white'] }],
            [{ script: 'sub' }, { script: 'super' }],
            ['blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }, { align: [] }],
            ['link', 'image', 'video'],
            ['clean'],
        ],
    };

    return (
        <ReactQuill
            {...props}
            modules={modules?? modulesDefault}
            // all my reactQuill with readOnly true didn't have module so I may think about linking them like this
            // modules={(!props?.readOnly) && (modules?? modulesDefault)}

            //theme={theme?? 'snow'}

            // was the reason of editor.getContent() error
            value={value || ''}
            placeholder={placeholder}
            onChange={(content,delta) => {
                if(!props?.readOnly){
                    console.log({content,delta});
                    setValue(content);
                    if(setIsReplanning)
                        setIsReplanning(true);
                }
            } }
            // readOnly={true}
            // theme={'bubble'}
            required
            style={(!!error && showErrors) ? invalidStyle : {width:'100%',borderRadius: '8px'}}
        />
    );
};
{/* <textarea
    name="#"
    id="#"
    cols="30"
    rows="10"
    className='textareatrasmettre'
></textarea>; */}

export default QuillAdvancedTextArea;
